import { Component, OnInit, inject, input } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { HelpLinkDirective } from '../../../../components/help-link/help-link.directive';
import { OverlayComponent } from '../../../../components/overlay/overlay.component';
import { OverlayToggleDirective } from '../../../../components/overlay/overlay-toggle.directive';
import { ANALYST_RATING_CONFIGURATION, AnalystRatingConfiguration } from './analyst-rating.component';

@Component({
  selector: 'td-wb-analyst-ratings-tooltip',
  templateUrl: 'analyst-rating-tooltip.component.html',
  styleUrls: ['analyst-rating-tooltip.component.scss'],
  imports: [
    OverlayToggleDirective,
    TranslateDirective,
    OverlayComponent,
    HelpLinkDirective
  ]
})
export class AnalystRatingTooltipComponent implements OnInit {
  private readonly analystRatingsConfiguration = inject<AnalystRatingConfiguration>(ANALYST_RATING_CONFIGURATION);

  readonly position = input<string>('center-right');

  newAnalystRatings: boolean;

  ngOnInit(): void {
    this.newAnalystRatings = this.analystRatingsConfiguration !== undefined && this.analystRatingsConfiguration.newAnalystRatings;
  }
}
